/**
 * 动态折线图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const dynamicLineValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'date', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'z', type: 'string', required: false }
  ],
  businessRules: [
    {
      name: 'dynamic-line-sufficient-data',
      validator: data => Array.isArray(data) && data.length > 1,
      message: 'Dynamic line chart requires more than 1 data point',
      suggestion: 'Provide at least 2 data points for dynamic animation',
      // 数据量建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
